
import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { state, commit, dispatch } = useStore()
    const carNumber = computed({
      get: () => state.autocall.carNumber,
      set: (value: string) => commit("autocall/SET_CARNUMBER", value),
    })
    const checkCarNumber = () => dispatch("autocall/checkCarNumber", carNumber.value)

    onMounted(() => {
      console.log(document.getElementById("carnumber_box"))
      setTimeout(() => {
        document.getElementById("carnumber_box")?.focus()
      }, 1000)
    })

    return {
      carNumber,
      checkCarNumber,
    }
  },
})
